export default __webpack_public_path__ + "static/media/way_1.76540679.jpg";